module.exports = __webpack_public_path__ + "static/MonicaDixon4-a5f58f97e6f31f0669f22062bd5bca49.jpg";